var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.98248H24V11.3496H0V5.98248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.615387H24V5.98248H0V0.615387Z",
    fill: "#CD1F2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -97.3846H24V16.6154H0V-97.3846Z",
    fill: "#1D4185"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.1013,
    fill: "white",
    transform: "translate(0 0.615387)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNl);
export default __webpack_public_path__ + "static/media/NL.8721e0eaef5ac1c20e6081024990e25b.svg";
export { ForwardRef as ReactComponent };